import React, { Component } from 'react'
import Modal from './components/Modal'
import Button from './components/Button'

class AddUser extends Component {
  state = {
    username: ''
  }

  handleClose = () => {
    this.props.onClose()
    setTimeout(() => this.setState({ username: '' }), 200)
  }

  render () {
    return (
      <Modal
        open={Boolean(this.props.show)}
        onClose={this.handleClose}
        title='Create User'
        footer={[
          <Button key='cancel' variant='ghost' onClick={this.handleClose}>Cancel</Button>,
          <Button
            key='save'
            onClick={() => {
              this.props.onSave(this.state.username)
              setTimeout(() => this.setState({ username: '' }), 200)
            }}
          >
            Save
          </Button>
        ]}
      >
        <label className='block text-sm font-medium text-slate-700'>
          Username
          <input
            type='text'
            className='mt-2 w-full rounded-xl border border-slate-200 px-3 py-2 focus:border-ink focus:ring-1 focus:ring-ink'
            value={this.state.username}
            onChange={e => this.setState({ username: e.target.value })}
          />
        </label>
        <p className='text-xs text-slate-500 mt-2'>Passcode will be generated automatically.</p>
      </Modal>
    )
  }
}

export default AddUser
